// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as PartnersHelper$PorterinFeature from "../../view/helpers/PartnersHelper.mjs";

function getPartnersCMSUrl(country_code, locale) {
  return Config$PorterinUtils.cms_url + "/api/website-partners-bd?populate[0]=hero_section.banner_img.image&populate[1]=hero_section.know_more_cta.href&populate[2]=hero_section.banner_img_mobile.image&populate[3]=porter_advantage.cards.icon&populate[4]=life_easy_section.icon&populate[5]=additioanal_benifits.cards.icon&populate[6]=testimonial_section.profiles.image&populate[7]=faq_section.faqs.answer&populate[8]=faq_section.toggle_icon.image&populate[9]=download_app.icon&populate[10]=faq_section.toggle_icon.image&populate[11]=partner_own_vehicle.image.image&populate[12]=partner_own_vehicle.action.target&populate[13]=meta_data.faq_schema&populate[14]=get_partner_cta.href" + ("&locale=" + locale + "");
}

function getPartnerVehiclesRequestUrl(geo_region_id) {
  var urlParams = PartnersHelper$PorterinFeature.getVehicleTypesParams(geo_region_id);
  return UrlUtils$Catalyst.createRequestURLfrmParams(Config$PorterinUtils.oms_url, "/geo_regions/vehicle_details_v2", urlParams);
}

function getSubmitVehicleFormUrlAndPayload(form) {
  var payloadString = JSON.stringify(PartnersHelper$PorterinFeature.encodeAttachVehicleForm(form));
  var requestUrl = Config$PorterinUtils.oms_url + "/vendor_contact_us";
  return [
          requestUrl,
          payloadString
        ];
}

export {
  getPartnersCMSUrl ,
  getPartnerVehiclesRequestUrl ,
  getSubmitVehicleFormUrlAndPayload ,
}
/* Config-PorterinUtils Not a pure module */
